module.exports = __webpack_public_path__ + "static/media/redux.08328b58.png";